import { PropsWithChildren } from "react";
import Drawer from "common/Drawers/Drawer.tsx";
import styled from "styled-components";
import useSwipeDrawer from "common/Gustures/useSwipeDrawer.ts";

interface SwipeDrawerProps {
  content?: JSX.Element;
}

const SwipeDrawer = ({
  content,
  children,
}: PropsWithChildren<SwipeDrawerProps>) => {
  const isDisabled = !content;
  const { open, closeDrawer, swipeDrawerProps } = useSwipeDrawer({
    isDisabled,
  });

  return (
    <SwipeDrawerWrapper {...swipeDrawerProps}>
      {children}
      <Drawer
        open={open}
        onClose={closeDrawer}
        width={300}
        placement="right"
        closable={false}
        destroyOnClose={false}
        styles={{ body: { padding: 16 } }}
      >
        {content}
      </Drawer>
    </SwipeDrawerWrapper>
  );
};

export default SwipeDrawer;

const SwipeDrawerWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;
